import * as React from "react";
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.css"
import Api, {APIs} from "../../../Api";

const PledgeInfo = () => {
    const [pivot, setPivot] = React.useState<any>(null)
    React.useEffect(() => {
        Api.get(APIs.MoPD_PLEDGE_INFO).then((payload) => {
            if (payload) {
                // console.log("pledge", payload)
                const pivot = new WebDataRocks({
                    container: "#wdr-component",
                    toolbar: true,
                    report: {
                        dataSource: {
                            // filename: "https://cdn.webdatarocks.com/data/data.csv"
                            data: payload
                        },
                        slice: {
                            rows: [
                                {
                                    uniqueName: "entity_type"
                                },
                                {
                                    uniqueName: "entity"
                                }
                            ],
                            columns: [
                                {
                                    "uniqueName": "Measures"
                                }
                            ],
                            measures: [
                                {
                                    uniqueName: "amount",
                                    aggregation: "sum"
                                },
                                {
                                    uniqueName: "loan",
                                    aggregation: "sum"
                                },
                                {
                                    uniqueName: "grant",
                                    aggregation: "sum"
                                }

                            ]
                        },
                        options: {
                            grid: {
                                type: "classic"
                            }
                        },
                        formats: [
                            {
                                "name": "",
                                "thousandsSeparator": ",",
                                "decimalSeparator": ".",
                                "currencySymbol": "$",
                                "currencySymbolAlign": "left",
                                "nullValue": "",
                                "textAlign": "right",
                                "isPercent": false
                            }
                        ]
                    }
                })
                setPivot(pivot)
            }

        })

        // setPivot(pivot)
    }, [])
    return (
        <>
            <div id={"wdr-component"}/>
        </>
    )
}

export default PledgeInfo
